import React, { useState, useEffect } from "react";
import { Table, Input } from "antd";
import EditAgModal from "./EditAgModal";
import { db } from '../../../db/db';

function EditAgTable() {
    const [data, setData] = useState([]);
    const [info, setInfo] = useState({});
    const [open, setOpen] = useState(false);
    const [searchedText, setSearchedText] = useState("");

    const statAgCol = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            filteredValue: [searchedText],
            onFilter: (value, record) => {
                return String(record.name)
                    .toLowerCase()
                    .includes(value.toLowerCase())
            }
        },
    ];

    const getStatAgData = () => {
        const statAgArr = [];
        db.collection('stateAgencies').doc('statAgs').get()
            .then(result => result.data().agencies)
            .then(docs => {
                for (let i = 0; i < docs.length; i += 1) {
                    statAgArr.push({
                        key: docs[i].key,
                        name: docs[i].name,
                    })
                }
                setData(statAgArr)
            })
    }

    useEffect(() => {
        getStatAgData()
    }, [])

    const rowClicked = (e, record) => {
        const data = {
            ...record
        }
        setInfo(data)
    };

    const onSubmit = async (saveData) => {
        const objIndex = data.findIndex((obj => obj.key == saveData.key));
        if (objIndex === -1) {
            data.push({
                name: saveData.name,
                key: saveData.key,
            })
        } else {
            data[objIndex].name = saveData.name
            data[objIndex].key = saveData.key
        }
        db.collection('stateAgencies').doc('statAgs').update({ agencies: data })
            .then(() => {
                getStatAgData();
                setOpen(false);
            })
    };

    const onDelete = async (saveData) => {
        const updatedData = data.filter(agency => agency.key !== saveData.key);
    
        db.collection('stateAgencies').doc('statAgs').update({ agencies: updatedData })
            .then(() => {
                getStatAgData();
                setOpen(false);
            })
            .catch(error => {
                console.error("Error deleting state agency: ", error);
            });
    };

    const centerPagination = "bottomCenter";
    return (
        <div>
            <Input.Search
                placeholder='Search State Agencies'
                style={{ marginBottom: 8 }}
                onSearch={(value) => {
                    setSearchedText(value);
                }}
                onChange={(e) => {
                    setSearchedText(e.target.value)
                }}
            />
            <Table
                onRow={(record) => ({
                    onClick: (event) => {
                        rowClicked(event, record);
                    },
                })}
                bordered
                size={'small'}
                columns={statAgCol}
                dataSource={data}
                pagination={{
                    position: [centerPagination],
                    hideOnSinglePage: true,
                }}
                scroll={{ y: 500 }}
                footer={() =>
                    <EditAgModal
                        info={info}
                        tableType={'State Agency'}
                        onSubmit={onSubmit}
                        onDelete={onDelete}
                        open={open}
                        setOpen={setOpen}
                    />
                }
            />
        </div>
    );
}

export default EditAgTable;